import React, {lazy} from "react";
import RequestService from "../../utils/fetch";

const ConditionalWrapper = lazy(() => import("../../utils/ConditionalWrapper"));

const SkeletonRandomJob = lazy(() => import("../Skeleton/RandomJob"));
import translations from "../../translations";


class TmsRandomJob extends React.Component {
    constructor(props) {
        super(props);
        const configName = "myTalentionConfig";
        const config = window[configName];

        this.state = {
            title: undefined,
            url: undefined,
            translations: translations[config.lang] ? translations[config.lang] : translations["de"],
            filterObject: {
                category: config.category || [],
            },
            configObject: config,
            paginationObject: {
                maxResults: 1,
            },
            interval: config.randomJob?.interval || config.randomJobInterval || 5000,
            isLoading: true,
        };

    }

    componentDidMount() {
        this.handleAPICall();
        this.handleInterval();
    }

    handleInterval() {
        const {interval} = this.state;
        setInterval(() => {
            this.handleAPICall();
        }, parseInt(interval));
    }

    handleAPICall() {
        const {filterObject, paginationObject, configObject} = this.state;
        RequestService.postRequest(
            `${configObject.clientURL}talention/api/3.2/job`,
            {
                filter: filterObject,
                pagination: {
                    max: paginationObject.maxResults,
                    offset: paginationObject.offset,
                },
            }
        ).then((data) => {
            this.setState({
                isLoading: false,
                title: data.results[0].title,
                url: data.results[0].url,
                paginationObject: {
                    ...this.state.paginationObject,
                    resultsTotal: data.resultsTotal,
                    offset: data.offset + 1 < data.resultsTotal ? data.offset + 1 : 0, // we check if it is the last job, when totalresults is equal offset + 1
                },
            });
        });
    }

    render() {
        const {title, url, configObject, translations} = this.state;
        return (
            <section className="tms-randomjob-wrap">

                <div className="tms-randomjob">
                    <ConditionalWrapper condition={configObject.randomJob?.wrapLink} wrapper={(children) => (
                        <a href={url} className={["tms-randomjob-link"].join(" ")}>
                            {children}
                        </a>
                    )}>
                        <p>{title || translations.loading}</p>
                    </ConditionalWrapper>
                    {configObject.randomJob?.hideButton ?
                        null : <a className="tms-randomjob-button"
                                  href={url}>{configObject.randomJob?.buttonText ? configObject.randomJob.buttonText : translations.toJob}</a>}
                </div>
            </section>
        );
    }
}

export default TmsRandomJob;
